// Widget Scripts
import experienceFair from './js/widgets/experienceFair';
import exploreFairgrounds from './js/widgets/exploreFairgrounds';
import fairCalendar from './js/widgets/fairCalendar';
import fairSwiper from './js/widgets/fairSwiper';
import fairgroundsSwiper from './js/widgets/fairgroundsSwiper';
import headerLinks from './js/widgets/headerLinks';
import multiScheduleFeature from './js/widgets/multiScheduleFeature';
import fairSeoWidget from './js/widgets/fairSeoWidget';
import fairgroundsSeoWidget from './js/widgets/fairgroundsSeoWidget';
import fairVideo from './js/widgets/fairVideo';
import fairgroundsVideo from './js/widgets/fairgroundsVideo';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Fairgrounds Widgets
if ($('body').hasClass('homepage')) {
  $(document).ready(function() {
    exploreFairgrounds();
    fairgroundsSeoWidget();
    fairgroundsSwiper();
    multiScheduleFeature();
  });

  $(window).load(function() {
    fairgroundsVideo();
  });
}

// Initialize Fair Widgets
if ($('body').hasClass('fair-homepage')) {
  $(document).ready(function() {
    experienceFair();
    fairCalendar();
    fairSwiper();
    fairSeoWidget();
  });

  $(window).load(function() {
    fairVideo();
  });
}

// Initialize Sitewide Widgets
$(document).ready(function() {
  headerLinks();
});